export default __webpack_public_path__ + "static/media/phani.582f970b.jpeg";